import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useFinishOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, OrderStatus.finished);

  return useApiMutation({
    url: `/orders/${orderId}/finished`,
    method: 'PATCH',
    errorTitle: 'Erro ao finalizar pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido finalizado!',
    onSuccess,
  });
};

export default useFinishOrder;
